import "./styles.scss";

import { Asset } from "../../models/asset";
import Checkups from "./components/checkups";
import OilChange from "./components/oilChange";
import usePeriodicReviews from "../../hooks/usePeriodcReviews";
import { useMediaQuery } from "@mui/material";

interface IIPeriodicReviewsProps {
  dialog: boolean;
  closeSidebar: () => void;
  asset: Asset | null;
  scheduleIds: string[];
  userRole: 'TOWER' | 'CONSULTANT' | 'MANAGER' | 'PARTNERSHIP';
}

const PeriodicReviews = ({ dialog, closeSidebar, asset, scheduleIds, userRole }: IIPeriodicReviewsProps) => {
  const { activeTab, setActiveTab, blockchainData, loading } = usePeriodicReviews({ chassis: asset?.chassis ?? "", scheduleIds, userRole, dialog });
  const isResponsiveView = useMediaQuery("(max-width: 768px)");

  return (
    <>
      <div className="bg-right-sidebar" onClick={() => closeSidebar()} />
      <div className={`right-sidebar ${isResponsiveView ? "!w-[80%]" : "!w-[450px]"}`}>
        <h3 className="flex gap-6 margin-bottom-20">
          <span className="rioglyph rioglyph-book"></span>
          Revisões Periódicas
        </h3>
        <div
          className="close-sidebar cursor-pointer"
          onClick={() => closeSidebar()}
        >
          <span className="rioglyph rioglyph-remove"></span>
        </div>

        <div className="w-full">
          <div className="p-0">
            {/* <div className="flex space-x-8 mb-6">
              <button
                onClick={() => setActiveTab("revisoes")}
                className={`text-size-16 font-semibold ${
                  activeTab === "revisoes"
                    ? "border-b-2 border-black"
                    : "text-gray-400"
                }`}
              >
                Revisões
              </button>
              <button
                // onClick={() => setActiveTab("trocaDeOleo")}
                className={`text-size-16 font-semibold ${
                  activeTab === "trocaDeOleo"
                    ? "border-b-2 border-black"
                    : "text-gray-400"
                }`}
                style={{ cursor: "not-allowed" }}
              >
                Troca de óleo
              </button>
            </div> */}

            {activeTab === "revisoes" && <Checkups asset={asset} blockchainData={blockchainData} loading={loading} />}

            {activeTab === "trocaDeOleo" && <OilChange asset={asset} blockchainData={blockchainData} loading={loading} />}
          </div>
        </div>
      </div>
    </>
  );
};

export default PeriodicReviews;
